<!-- ICON -->
<div class="dropdown nav-button notifications-button hidden-sm-down">
  <a class="button-style" href="#" id="notifications-dropdown" data-toggle="dropdown"
    aria-haspopup="true" aria-expanded="false">
    <span id="notificationsIcon" class="material-symbols-outlined" aria-hidden="true">
      notifications
    </span>
  </a>

  <!-- HEADER DE NOTIFICACIONES -->
  <div class="dropdown-menu notification-show" aria-labelledby="notifications-dropdown">
    <h6 class="dropdown-header">Notificaciones</h6>
    <div id="notificationsContainer" class="notifications-container">
      <ul>
        @for (notification of this.notifications; track notification) {
          <li>
            <a class="dropdown-item dropdown-notification" href="#">
              <div class="notification-read">
                <em class="fa fa-times" aria-hidden="true"></em>
              </div>
              <div class="notifications-body">
                <span class="notification-text notification-header">
                  @if (notification.type == 'Fuente') {
                    <span>
                      <em class="fa fa-database notification-typeIcon"></em>
                    </span>
                  } @else {
                    <em class="fa fa-exclamation-triangle notification-typeIcon"></em>
                  }
                  {{notification.title}}
                </span>
                <p class="notification-text">{{notification.text}}</p>
                <p class="notification-date text-muted">
                  <em class="fa fa-clock notification-clockIcon" aria-hidden="true"></em>{{notification.date}}
                </p>
              </div>
            </a>
          </li>
        }
      </ul>
    </div>
    <a class="dropdown-item dropdown-notification-all" href="#">
      Ver todo
    </a>
  </div>
</div>
